module.exports = __webpack_public_path__ + "static/img/0.340a865.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mockups/screenshots/0.jpg
// module id = wnle
// module chunks = 0